export default "__VITE_ASSET__DSFgmbsk__"